import React from "react";

const CartInfo = ({ basket }) => {
    let price = 0;
    price = basket?.reduce((amount, item) => amount + item?.price, 0) ?? 0;
    return (
        <div
            className="cart-info">
            <span>Total Items: ({basket ? basket.length: 0})</span>
            <span>Total Price: ${price.toFixed(2)}</span>
        </div>
    )
}

export default CartInfo;